module.exports = __webpack_public_path__ + "static/media/  (32).a2ab2b26.jpg";